import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemeralSession = (
  sessionId: string | undefined,
  setSession: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);
  ApiService.get(`ephemeral-evaluations/sessions/${sessionId}`)
    .then((response) => setSession(response.data.ephemeral_session))
    .catch((error) => {
      console.error("Error fetching ephemeral session:", error);
      alert(translate(language, "PAGES.EPHEMERAL_SESSION.ERROR"));
    })
    .finally(() => setLoaded(true));
};
